/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './intra-op-count.reducer';

export const IntraOPCount = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const intraOPCountList = useAppSelector(state => state.intraOPCount.entities);
  const loading = useAppSelector(state => state.intraOPCount.loading);
  const totalItems = useAppSelector(state => state.intraOPCount.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="intra-op-count-heading" data-cy="IntraOPCountHeading">
        <Translate contentKey="tinyMedicRestApp.intraOPCount.home.title">Intra OP Counts</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.intraOPCount.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/intra-op-count/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.intraOPCount.home.createLabel">Create new Intra OP Count</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.intraOPCount.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {intraOPCountList && intraOPCountList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('countType')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.countType">Count Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('countType')} />
                </th>
                <th className="hand" onClick={sort('sponges')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.sponges">Sponges</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sponges')} />
                </th>
                <th className="hand" onClick={sort('gauze')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.gauze">Gauze</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('gauze')} />
                </th>
                <th className="hand" onClick={sort('peanut')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.peanut">Peanut</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('peanut')} />
                </th>
                <th className="hand" onClick={sort('cottonoid')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.cottonoid">Cottonoid</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cottonoid')} />
                </th>
                <th className="hand" onClick={sort('vesselLoop')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.vesselLoop">Vessel Loop</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('vesselLoop')} />
                </th>
                <th className="hand" onClick={sort('rollerGauze')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.rollerGauze">Roller Gauze</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('rollerGauze')} />
                </th>
                <th className="hand" onClick={sort('instrument')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.instrument">Instrument</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('instrument')} />
                </th>
                <th className="hand" onClick={sort('needle')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.needle">Needle</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('needle')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.intraOPCount.nursingRecord">Nursing Record</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {intraOPCountList.map((intraOPCount, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/intra-op-count/${intraOPCount.id}`} color="link" size="sm">
                      {intraOPCount.id}
                    </Button>
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.CountType.${intraOPCount.countType}`} />
                  </td>
                  <td>{intraOPCount.sponges}</td>
                  <td>{intraOPCount.gauze}</td>
                  <td>{intraOPCount.peanut}</td>
                  <td>{intraOPCount.cottonoid}</td>
                  <td>{intraOPCount.vesselLoop}</td>
                  <td>{intraOPCount.rollerGauze}</td>
                  <td>{intraOPCount.instrument}</td>
                  <td>{intraOPCount.needle}</td>
                  <td>{intraOPCount.active ? 'true' : 'false'}</td>
                  <td>{intraOPCount.cursor}</td>
                  <td>{intraOPCount.lastupdated}</td>
                  <td>{intraOPCount.microSec}</td>
                  <td>{intraOPCount.timestampentry}</td>
                  <td>
                    {intraOPCount.nursingRecord ? (
                      <Link to={`/intra-op-nursing-record/${intraOPCount.nursingRecord.id}`}>{intraOPCount.nursingRecord.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/intra-op-count/${intraOPCount.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/intra-op-count/${intraOPCount.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/intra-op-count/${intraOPCount.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.intraOPCount.home.notFound">No Intra OP Counts found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={intraOPCountList && intraOPCountList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default IntraOPCount;
